<template lang="pug">
  a-entity.tutorial
    .content(ref="content")
      slides(ref="slides" @progress="slideProgressHandeler" @transitionStart="onTransitionStart")
      slide(:active="1" :idx="currIdx")
    //logo
    logo-sprite(ref="logo")

    .start(:class="[{'active': showCta}, {'hide': hideCta}]" @click="btnStart")
      .circle(:style="`transform: scale(${nextProgress*5})`")
      .circle-active(v-if="nextActivated")
      .copy 开始体验
    tutor-trans(ref="tutorTrans" @cueIn="setCurrIdx" :idx="currIdxTemp")
    .bottom(ref="bottom")
      .button-skip(@click="btnSkip" :class="[{'hide': showCta}]")
        .circle-active(v-if="nextActivated")
        .copy 跳过
      .button-skip-clickable(@click="btnSkip")
        //.clickable(@click="btnSkip")
          //icon-arrow
      goo-pagination(ref="goo" :currSceneIdx="currIdx")

    .tutor-cta(ref="cta")
      .copy
        .line 轻松玩转加州
        .line 先学会这几招吧
      waveline


</template>
<script>

import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3} from 'gsap'
import Slides from '@/components/vca/tutorial/Slides2'
import LogoSprite from 'src/components/vca/widgets/LogoSprite'
import IconArrow from 'src/components/vca/widgets/IconArrow'
import AudioPlayer from 'src/components/vca/widgets/AudioPlayer'

import GooPagination from "../widgets/GooPagination3";
import AnalyticsService from '@/services/AnalyticsService'
import Waveline from 'src/components/vca/widgets/Waveline'

import Slide from 'src/components/vca/tutorial/Slide'
import TutorTrans from "./TutorTrans2";

export default {
  name: "Tutorial",
  props: {

  },
  components: {
    TutorTrans,
    GooPagination,
    Slides,
    IconArrow,
    LogoSprite,
    AudioPlayer,
    Waveline,
    Slide
  },
  data() {
    return {
      nextProgress: 0,
      nextActivated: false,
      showCta: false,
      hideCta: false,
      currIdx: 0,
      currIdxTemp: 0,
      progress: 0,
      pattern: null,
      transitionStart: false
    }
  },
  computed:{
    ...mapState('browser', ['isMobile', 'windowHeight', 'windowWidth', 'isAndroid']),

  },
  methods: {

    init() {
      this.pattern = document.getElementById('a-pattern')

    },
    updateProgress(){
      this.progress = this.progress + (this.slideProgress - this.progress) * 0.1

    },
    animateIn() {
      let tl = new TimelineMax({ onComplete: () => {

        } })
      this.tl = tl

      //console.log(this.$el.getBoundingClientRect(), this.$el.offsetHeight)
      //console.log(444, this.$refs.btns.childNodes)
      tl.add('start')
        .set(
          this.$refs.logo.$el,
          {
            y: -window.innerHeight/2
          },
          `start+=0`
        )
        .set(
          this.$refs.bottom,
          {
            y: window.innerHeight/2
          },
          `start+=0`
        )
        .set(
          this.$refs.content,
          {
            x: window.innerWidth
          },
          `start+=0`
        )
        .set(
          this.$refs.cta,
          {
            x: window.innerWidth
          },
          `start+=0`
        )

        .to(
          this.$refs.logo.$el,
          0.7,
          {
            y: 0,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          this.$refs.cta,
          0.7,
          {
            x: 0,
            ease: Power2.easeOut
          },
          `start+=0.5`
        )
        .to(
          this.$refs.cta,
          0.7,
          {
            x: -window.innerWidth,
            ease: Back.easeIn.config(3)
          },
          `start+=2.5`
        )

        .to(
          this.$refs.content,
          0.7,
          {
            x: 0,
            ease: Power2.easeOut
          },
          `start+=3`
        )
        .to(
          this.$refs.bottom,
          0.7,
          {
            y: 0,
            ease: Power2.easeOut
          },
          `start+=3.2`
        )
    },
    animeOut(cb){
      //this.ofs -= 5000
      let tl = new TimelineMax({ onComplete: () => {
          cb()
        } })
      this.tl = tl

      //console.log(this.$el.getBoundingClientRect(), this.$el.offsetHeight)
      //console.log(444, this.$refs.btns.childNodes)
      tl.add('start')
        .to(
        this.$el,
        1,
        {
          x: -window.innerWidth,
          ease: Power2.easeIn,
        },
        `start+=1`
        )
        .to(
          this.$refs.goo.$el,
          0.7,
          {
            x: -window.innerWidth,
            ease: Power2.easeIn,
          },
          `start+=0`
        )
        .to(
          this.$refs.logo.$el,
          0.7,
          {
            x: -window.innerWidth,
            ease: Power2.easeIn,
          },
          `start+=0.8`
        )
    },

    setCurrIdx(){
      let id = this.currIdxTemp
      this.currIdx = id
      AnalyticsService.sendPageview(`/tutorial/0${id+1}`)
      //console.log(id)
      if (id===3)
        this.showCta = true
      else
        this.showCta = false
    },
    onTransitionStart(id){
      //console.log('!!!!', this.currIdxTemp, id)
      if (this.nextActivated) return
      if (this.currIdxTemp < id) {
        this.$refs.tutorTrans.animeLeft()
      } else {
        this.$refs.tutorTrans.animeRight()
      }

      //this.transitionStart = true

      this.currIdxTemp = id
    },
    onSlideChange(id){
      this.currIdx = id
      AnalyticsService.sendPageview(`/tutorial/0${id+1}`)
      //console.log(id)
      if (id===3)
        this.showCta = true
      else
        this.showCta = false
    },
    slideProgressHandeler(p){
      //console.log(9990, p)
      //if (this.pattern)
        //this.pattern.components['pattern'].progress = p


      if (p >= 1) {
        let pp = (p-1)/0.06
        //console.log(p-1)
        this.nextProgress = pp
        if (!this.nextActivated && pp>1){
          this.nextActivated = true
          this.next()
        }

      }

    },
    inQuart(n) {
    return n * n * n * n
    },
    btnSkip(){
      AnalyticsService.sendEvent('tutorial', 'click', 'button-skip')
      this.next()
    },
    btnStart(){
      AnalyticsService.sendEvent('tutorial', 'click', 'button-start')
      this.next()
    },
    next(){
      this.nextActivated = true


      //this.$emit('next')
      //window.Slide4.stop()
      //window.App.tutorComplete()

      let cb = () => {
        //let offset = window.Slide4.$children[0].getTranslate()
        //window.App.tutorComplete()
        this.$router.replace({
          name: 'welcome',
        })
      }

      if (this.currIdx !== 3) {
        console.log('lll')
        //this.$refs.slides.swiper.slideTo(3, 1000)
        let gap = 3-this.currIdx

        for (let i=1;i<=gap;i++){
          setTimeout(() =>{
            this.currIdx = this.currIdx+1
            console.log('kkk')
            this.$refs.slides.swiper.slideTo(this.currIdx)
          }, this.inQuart(i/gap)*250)
        }

        setTimeout(() => {
          this.hideCta = true
          window.Slide4.animeOut(cb)
          //console.log(window.Slide4.$children[0].getTranslate())
          //window.Slide4.animeOut()
          this.animeOut(cb)
          //window.App.welcomeSetup()

        }, 1000)
      } else {
        window.Slide4.animeOut()
        this.animeOut(cb)
        this.hideCta = true
        //window.Slide4.animeOut(cb)
        //window.App.welcomeSetup()
      }

    }
  },
  mounted() {
    this.init()
    this.animateIn()
    AnalyticsService.sendPageview('/tutorial')

  },
  beforeDestroy(){
    //Raf.remove(this.updateProgress)
  },
  watch: {

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .tutorial
    //pointer-events: none
    +full()
    //background: #cf3503
    //background: linear-gradient(21.07deg, #2752A3 14.22%, #5E80D4 89.05%)
    .logo
      z-index: 99
    .logo-sprite
      z-index: 99
    .tutor
      z-index: 70
    .goo-pagination
      z-index: 199
    .content
      z-index: 90
      +full()
    .tutor-trans
      z-index: 91
    .bottom
      //pointer-events: none
      line-height: 0
      bottom: 0
      position: absolute
      width: 100%
      height: 0.8rem
      z-index: 110
      //background: #3a602e

    .button-skip-clickable
      z-index: 200
      position: absolute
      //line-height: 1rem
      width: 1rem
      height: 1rem
      //background: #e15125
      right: 0.05rem
    .button-skip
      //pointer-events: all
      background: rgba(255, 255, 255, 0.1)
      z-index: 199
      position: absolute
      line-height: 0
      border-radius: 0.15rem*1.4
      width: 0.6rem*1.4
      height: 0.3rem*1.2
      //padding: 0.1rem 0.2rem
      bottom: $ui-margin-top - 0.54rem
      right: 0.2rem
      display: flex
      align-items: center
      justify-content: center
      overflow: hidden
      transition: all 0.7s ease
      opacity: 1
      box-shadow: rgba(0, 0, 0, 0.08) 1px 1px 1px

      &.hide
        transform: translateX(200%)
        opacity: 0
      .circle
        //transform: scale(0.2) !important
        transform-origin: center
        position: absolute
        top: -0.12rem
        left: 0
        width: 0.53rem
        height: 0.53rem
        border-radius: 50%
        background: #d9d9d9
        z-index: 9
      .circle-active
        //transform: scale(0.2) !important
        position: absolute
        top: -0.12rem
        left: 0
        width: 0.53rem
        height: 0.53rem
        border-radius: 50%
        background: #ffffff
        z-index: 10
        animation-name: circleActive
        animation-duration: 0.4s
        animation-timing-function: ease-out
        animation-fill-mode: both
      .copy
        line-height: $fs-s
        color: white
        font-size: $fs-s
        //background: #e15125
        margin-left: 5px
        z-index: 11
        text-shadow: 2px 2px 6px rgba(0,0,0,0.1)
      //.icon-arrow
        z-index: 11
        position: relative
    .start
      z-index: 750
      position: absolute
      transform: translate3d(300%, 0, 0)
      opacity: 0
      left: 50%
      //bottom: 0.3rem
      top: calc(100% - 1.5rem)
      background: #E38203
      font-size: $fs-xl
      line-height: 2
      border-radius: $fs-xl
      text-align: center
      width: 2.5rem
      margin-left: -1.25rem

      pointer-events: all
      overflow: hidden
      .circle
        //transform: scale(1) !important
        position: absolute
        top: 50%
        left: 50%
        width: 0.53rem
        height: 0.53rem
        margin-left: -0.265rem
        margin-top: -0.265rem
        border-radius: 50%
        background: #f8deb1
        z-index: 9
      .circle-active
        //transform: scale(0.2) !important
        position: absolute
        top: 50%
        left: 50%
        width: 0.53rem
        height: 0.53rem
        margin-left: -0.265rem
        margin-top: -0.265rem
        border-radius: 50%
        background: #ffffff
        z-index: 10
        animation-name: circleActive
        animation-duration: 0.4s
        animation-timing-function: ease-out
        animation-fill-mode: both
      .copy
        position: relative
        color: $cl-lightGold
        z-index: 11
      &.active
        will-change: transform
        transform: translate3d(0, 0, 0)
        transition-duration: 1s
        transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1)
        transition-property: transform
        transition-delay: 0.3s
        opacity: 1
      &.hide
        transition: all 0.7s ease-in 0.2s
        transform: translate3d(-300%, 0, 0)
        opacity: 0
  .tutor-cta

    animation: slideout
    animation-duration: 0.7s
    animation-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045)
    animation-fill-mode: both
    animation-delay: 3s
    +full()
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    z-index: 110
    .copy
      width: 100%
      text-align: center
      font-size: $fs-m
      color: #fff
      line-height: 1.5
    .waveline
      width: 1.2rem
      margin: 0.1rem auto 0 auto
      z-index: 100
      position: relative
      top: auto


  @keyframes circleActive
    0%
      transform: scale(0)
      opacity: 0
    80%
      opacity: 1
    100%
      transform: scale(8)
      opacity: 0

</style>